const WORDS = ["Personal presencial", "Consultoria online", "Consultoria mista", "Treino feminino", "Força", "Constância", "Método"];

const Row = ({ items, className, testid }) => (
  <div className={`flex w-max ${className}`} data-testid={testid}>
    {[...items, ...items].map((w, i) => (
      <span key={i} className="flex items-center gap-10 px-5 font-display text-5xl font-900 uppercase leading-none md:text-8xl">
        {w}
        <svg viewBox="0 0 20 20" className="h-6 w-6 shrink-0 md:h-10 md:w-10" aria-hidden><path d="M10 0 L12 8 L20 10 L12 12 L10 20 L8 12 L0 10 L8 8 Z" fill="#E0B25C" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 bg-[var(--ink)] py-10 md:py-14" data-testid="marquee-section">
    <Row items={WORDS} className="animate-marquee" testid="marquee-row-main" />
    <div className="mt-4 opacity-40">
      <Row items={[...WORDS].reverse()} className="animate-marquee-fast text-outline" testid="marquee-row-outline" />
    </div>
  </section>
);
